import { apiClient } from './api';
import type { ApiResponse } from '@/types';
import type { ChannelType } from './channelsService';

export type DashboardRange = 'today' | '7d' | '30d';

export interface DashboardMetrics {
  range: DashboardRange;
  channel: ChannelType | 'all';
  sent: number;
  success_rate: number;
  contacts: number;
}

export interface GetDashboardMetricsParams {
  range: DashboardRange;
  channel: ChannelType | 'all';
}

export async function getDashboardMetrics(params: GetDashboardMetricsParams): Promise<ApiResponse<DashboardMetrics>> {
  return apiClient.get<DashboardMetrics>('/dashboard/metrics', params);
}
